import React, { useContext } from "react";
import { AppStateContext, EloginStatus } from "../../../app-state";
import { AccountInfo } from "./AccountInfo";
import { Link } from "react-router-dom";
import { Icon } from "../../../core/Icon";
export const FullHeader = () => {
    const { state, dispatch } = useContext(AppStateContext);
    return (React.createElement("header", { className: "full-header" },
        React.createElement("div", { className: "container" },
            React.createElement("div", { className: "full-header-inner" },
                React.createElement(Link, { to: "/cs/seznam/nejblizsi-aukce", className: "left-side" },
                    React.createElement("div", { className: "app-logo", "aria-hidden": true })),
                React.createElement("div", { className: "right-side" },
                    state.loginState == EloginStatus.Logged && React.createElement(AccountInfo, null),
                    state.loginState == EloginStatus.Public && (React.createElement("div", { className: "account-links" },
                        React.createElement(Link, { className: "login-link", to: "/cs/proces/prihlaseni-uzivatele" },
                            React.createElement(Icon, { c: ['user', 14, 14] }),
                            "P\u0159ihl\u00E1sit se"),
                        React.createElement(Link, { className: "register-link", to: "/cs/proces/registrace" },
                            React.createElement(Icon, { c: ['lock', 14, 14] }),
                            "Registrace"))))))));
};
